import debug from "debug";

const MODULE_NAME = 'app.core/modules/colour-picker';
const log = debug(MODULE_NAME);

export function exec () {
    $('.colorPicker').each(function () {
        const $component = $(this);
        log($component);
        $component.find('.colour-box')
            .on('mouseover', function () {
                const colour = $(this).siblings('.colourName').text();
                log(this, {colour});
                $component.attr('data-colour-name', colour);
            })
            .on('mouseout', function () {
                $component.attr('data-colour-name', '');
            });
    });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/colour-picker/index.js